import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=0caf5d10&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=0caf5d10&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf5d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0caf5d10')) {
      api.createRecord('0caf5d10', component.options)
    } else {
      api.reload('0caf5d10', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=0caf5d10&scoped=true", function () {
      api.rerender('0caf5d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/banner.vue"
export default component.exports